<template>
  <div>
    <div class="canvas-carousel">
      <!-- Wrapper for slides -->
      <div class="canvas-carousel-inner" data-currentimage="0">
        <img src="@/img/hensel-loading.svg" alt="loading" style="margin: 0 auto; display: block" v-if="processedImages.length === 0">
        <carousel :per-page="1" :navigationEnabled="true" :adjustableHeight="true" v-else>
          <slide
              v-for="image in processedImages"
              :key="`slide-${watermark}-${image}`"
          >
            <combined-image
                v-if="watermark"
                :filename="image"
                :zoomable="true"
                :user-id="watermark"
                @process-img="forwardProcessImgEvent"
                @start-zooming="zoomImage"
                :key="`image-${watermark}-${image}`"
            />
          </slide>
        </carousel>
      </div>
      <!-- Controls -->
    </div>
    <pinch-zoom-overlay :image="zoomedImage" @hide="zoomedImage = null"/>

  </div>
</template>

<script>
import forwardEvents from '../mixins/forwardEvents.js'
import { Carousel, Slide } from 'vue-carousel'
import CombinedImage from '../components/CombinedImage'
import PinchImage from '../components/PinchImage'
import PinchZoomOverlay from './PinchZoomOverlay'
import System from '@/_system.js'

export default {
  name: 'CanvasCarousel',
  mixins: [forwardEvents],
  components: {
    PinchZoomOverlay,
    CombinedImage,
    Carousel,
    Slide,
    PinchImage,
  },
  props: {
    images: Array,
    watermark: String,
  },
  data () {
    return {
      zoomedImage: null,
      processedImages: [],
      loading: true
    }
  },
  methods: {
    zoomImage (imageData) {
      this.zoomedImage = imageData
    },
    processImage(image) {
      return new Promise((resolve) => {
        this.$emit('process-img', this.watermark, image.id, imageData => {
          resolve(imageData)
        })
      })
    },
    async loadImage(image) {
      try {
        const { data } = await System.readFile(`${this.watermark}-${image.id}.dat`)

        if (data) {
          if (data.startsWith('data:')) {
            return data
          } else {
            return 'data:image/png;base64,' + data
          }
        } else {
          return this.processImage(image)
        }
      } catch (err) {
        return this.processImage(image)
      }
    }
  },
  async mounted () {
    try {
      // pre-process the images to prevent a bug in Chrome where the carousel is rendered with a height of 0
      this.processedImages = await Promise.all(this.images.map(image => this.loadImage(image)))
    } catch (err) {
      console.error('error while preloading images', err)
    } finally {
      this.$nextTick(() => this.$forceUpdate())
    }
  }
}
</script>
